/**
 * Pure detector for "has this scrollable element been scrolled to (or past) its bottom".
 *
 * Kept free of the DOM so it can be unit-tested with exact metrics (jsdom does not compute
 * layout, so `scrollHeight`/`clientHeight` are always 0 there). Used to gate the login terms
 * "Accept" button until the member has read to the end of the terms.
 *
 * - A small `threshold` (px) tolerates sub-pixel rounding and momentum-scroll overshoot so the
 *   member doesn't have to hit the exact last pixel.
 * - When the content fits within the box (nothing to scroll), it counts as fully read — otherwise
 *   the button could never enable for short terms.
 */
export const isScrolledToBottom = (
  el: Pick<HTMLElement, "scrollTop" | "clientHeight" | "scrollHeight">,
  threshold = 16,
): boolean => {
  if (el.scrollHeight <= el.clientHeight + threshold) return true;
  return el.scrollHeight - el.scrollTop - el.clientHeight <= threshold;
};
